import { Vehicle } from '../../../../../../common/types/Vehiculo'

function num(value: unknown, fallback = 0): number {
  if (typeof value === 'number' && !Number.isNaN(value)) return value
  if (typeof value === 'string' && value !== '') {
    const n = Number(value)
    return Number.isNaN(n) ? fallback : n
  }
  return fallback
}

function str(value: unknown, fallback = ''): string {
  if (value == null) return fallback
  return String(value)
}

/** Respuesta GET `/vehiculos/:matricula` — cuerpo con `vehicleData`. */
export function mapVehiculoMatriculaApiToVehicles(payload: unknown): Vehicle[] {
  if (!payload || typeof payload !== 'object') return []

  const record = payload as Record<string, unknown>
  const list = record.vehicleData

  if (!Array.isArray(list)) return []

  return list
    .filter((item): item is Record<string, unknown> =>
      Boolean(item && typeof item === 'object')
    )
    .map(
      (raw): Vehicle => ({
        cod_matricula: str(raw.cod_matricula),
        ano_matric: num(raw.ano_matric),
        mes_matric: str(raw.mes_matric),
        ano_fabric: num(raw.ano_fabric),
        marca: str(raw.marca),
        combustible_tipo: str(raw.combustible_tipo),
        id_marca: num(raw.id_marca),
        modelo: str(raw.modelo),
        motor: str(raw.motor),
        imagen: str(raw.imagen),
        fecha_desde: str(raw.fecha_desde),
        potencia_cv: num(raw.potencia_cv),
        potencia_kw: num(raw.potencia_kw),
        potencia_cilindrada: num(raw.potencia_cilindrada),
        cod_motor: str(raw.cod_motor),
        capacidad_carter: str(raw.capacidad_carter),
        id_modelo: num(raw.id_modelo),
        id_vehiculo: num(raw.id_vehiculo),
        carroceria: str(raw.carroceria),
        id_vehiculo_ami: num(raw.id_vehiculo_ami),
        id_vivid: num(raw.id_vivid),
      })
    )
    .filter((v) => v.id_vehiculo > 0)
}
